import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { Divider, Spinner, Typography } from '@telus-uds/components-web';

import request from '../../utils/request';

import { ContentWrapper, Box } from '../../design/css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderStatus } from '../../utils/constant';
import { getFormattedDate } from '../../utils/utils';
import useFetchContentfulData from '../../hooks/useFetchContentfulData';

import Table from './Table';
import Pagination from '../iotOrderFulfillmentDashboard/Pagination';
import SearchBar from '../iotOrderFulfillmentDashboard/components/searchBar';
import Filters from '../iotOrderFulfillmentDashboard/components/filters';
import ExportReport from '../iotOrderFulfillmentDashboard/components/exportReport';

const IotSalesRepDashboard = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;
  const { data: pageLayout } = useFetchContentfulData('iotSalesRepDashboard');
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [filters, setFilters] = useState({
    iotProductSelected: [],
    status: [],
    flag: [],
    assignedUserId: [],
    createdBy: [],
    province: [],
    channelId: [],
    filterCriteria: '',
    endDateOpenDate: '',
    endDateSubmissionDate: '',
    startDateOpenDate: '',
    startDateSubmissionDate: ''
  });

  const {
    incomplete,
    pendingValidation,
    waitingOnCredit,
    waitingOnSales,
    contractSigned,
    contractSent,
    orderCanceled,
    contractExpired,
    orderInstalled,
    orderPlaced,
    orderActivated,
    orderShipped,
    orderCompleted
  } = orderStatus;

  const getPayload = () => {
    const payload = {
      ...filters,
      pageNumber,
      pageSize: _.get(pageLayout, 'ordersPerPage', 10),
      type: 'IOT',
      status: filters.status.length || [
        incomplete,
        pendingValidation,
        waitingOnCredit,
        waitingOnSales,
        contractSigned,
        contractSent,
        orderCanceled,
        contractExpired,
        orderInstalled,
        orderPlaced,
        orderActivated,
        orderShipped,
        orderCompleted
      ]
    };

    if (filters.iotProductSelected)
      payload.iotProductSelected = filters.iotProductSelected.map(
        row => row.value
      );
    if (filters.status.length)
      payload.status = filters.status.map(row => row.value);
    if (filters.flag) payload.flag = filters.flag.map(row => row.value);
    if (filters.assignedUserId)
      payload.assignedUserId = filters.assignedUserId.map(row => row.value);
    if (filters.createdBy)
      payload.createdBy = filters.createdBy.map(row => row.value);
    if (filters.province)
      payload.province = filters.province.map(row => row.value);
    if (filters.channelId)
      payload.channelId = filters.channelId.map(row => row.value);
    if (filters.dealership)
      payload.dealership = filters.dealership.map(row => row.value);
    if (filters.startDateOpenDate)
      payload.startDate = getFormattedDate(filters.startDateOpenDate);

    if (filters.endDateOpenDate)
      payload.endDate = getFormattedDate(filters.endDateOpenDate);

    if (filters.startDateSubmissionDate) {
      payload.startDate = getFormattedDate(filters.startDateSubmissionDate);
    }
    if (filters.endDateSubmissionDate)
      payload.endDate = getFormattedDate(filters.endDateSubmissionDate);

    if (filters.startDateOpenDate || filters.endDateOpenDate)
      payload.filterCriteria = 'createdAt';

    if (filters.startDateSubmissionDate || filters.endDateSubmissionDate)
      payload.filterCriteria = 'validatedAt';

    delete payload.startDateOpenDate;
    delete payload.endDateOpenDate;
    delete payload.endDateSubmissionDate;
    delete payload.startDateSubmissionDate;

    return payload;
  };

  const setOrders = data => {
    setOrdersList(_.get(data, 'data.results', []));
    setTotalOrders(_.get(data, 'data.totalCount', 0));
  };

  const fetchOrders = () => {
    setPageLoading(true);
    request
      .post('/orders/filter', getPayload())
      .then(response => {
        setOrders(response);
        setPageLoading(false);
      })
      .catch(() => {
        setPageLoading(false);
      });
  };

  useEffect(() => {
    fetchOrders();
  }, [pageNumber]);

  return (
    <>
    <Divider space={1} variant={{ inverse: true }} />
      <ContentWrapper style={{ maxWidth: '92%', margin: '0 auto', padding: 0 }}>
        <Box>
          <Filters
            setOrders={setOrders}
            filters={filters}
            setFilters={setFilters}
            getPayload={getPayload}
            includeIncompleteStatus
            setPageNumber={setPageNumber}
          />
          <Divider space={1} variant={{ inverse: true }} />
          <SearchBar setOrders={setOrders} fetchOrders={fetchOrders} />
          <>
            {pageLoading ? (
              <Spinner show label="Loading Orders..." />
            ) : (
              <>
                {!pageLoading && ordersList.length === 0 ? (
                  <Typography heading="h3" variant={{ size: 'h3' }} block>{noOrders}</Typography>
                ) : (
                  <div className="table-container-main">
                    <div
                      className="table-wrapper"
                      style={{
                        border: '1px solid #e3e3e3'
                      }}
                    >
                      <Table
                        pageLayout={pageLayout}
                        data={ordersList}
                        fetchOrders={fetchOrders}
                        totalOrders={totalOrders}
                      />
                    </div>
                    <Pagination
                      ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
                      totalOrders={totalOrders}
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                    />
                    <ExportReport getPayload={getPayload} />
                  </div>
                )}
              </>
            )}
          </>
        </Box>
      </ContentWrapper>
    </>
  );
};

export default IotSalesRepDashboard;
